import { PcaChatTooltip } from './subcomponents/PcaChatTooltip/PcaChatTooltip';
import { usePcaChatModalContext } from './contexts/PcaChatModalContext';
import { PcaChatWelcomeScreen } from './subcomponents/PcaChatWelcomeScreen/PcaChatWelcomeScreen';
import { PcaChat } from './subcomponents/PcaChat/PcaChat';

export const PcaChatModal = () => {
  const { pcaChatModalState } = usePcaChatModalContext();

  switch (pcaChatModalState) {
    case 'tooltip':
      return <PcaChatTooltip />;
    case 'welcome':
      return <PcaChatWelcomeScreen />;
    case 'chat':
      return <PcaChat />;
    default:
      return null;
  }
};
